<script setup>
import { useSlots, defineProps, computed } from "vue";

const slots = useSlots();

const props = defineProps({
  filters: {
    type: Object,
    default: () => ({}),
  },
  filterItems: {
    type: Function,
    default: () => {},
  },
  resetFilter: {
    type: Function,
    default: () => {},
  },
});

const hasSlot = (name) => {
  return !!slots[name];
};

const checkFilters = computed(() => {
  let trueKeys = [];
  for (const key in props.filters) {
    if (Object.hasOwnProperty.call(props.filters, key)) {
      if (
        props.filters[key] ||
        props.filters[key] === 0 ||
        props.filters[key] === false
      ) {
        trueKeys.push(key);
      }
    }
  }
  return trueKeys.length || Object.keys(props.filters).length;
});
</script>

<template>
  <div class="pageheader">
    <div class="pageheader__wrapper">
      <div class="pageheader__wrapper-left">
        <div class="pageheader__wrapper-left-title">
          <h2>
            <slot name="title"></slot>
          </h2>
          <template v-if="hasSlot('sub-title')">
            <div class="pageheader__wrapper-line"></div>
            <h4><slot name="sub-title"></slot></h4>
          </template>
        </div>
        <!-- <h2></slot>
          
        </h2> -->
        <div class="pageheader__wrapper-subtitle">
        
          <div class="pageheader__wrapper-right-button">
            <slot name="extra-button"></slot>
          </div>
        </div>
      </div>
      <div class="pageheader__wrapper-right">
        <slot name="actions"></slot>
      </div>
    </div>
    <form
      @submit.prevent="filterItems"
      class="pageheader__filters"
      v-if="hasSlot('filters')"
    >
      <div class="pageheader__content">
        <div class="pageheader__filters-fields">
          <slot name="filters"></slot>

          <div class="pageheader__filters-buttons">
            <slot name="buttons">
              <button type="submit" :disabled="checkFilters === 0">
                <i class="filter" style="fill: red !important"></i>
                <span>Filter</span>
              </button>

              <button
                :disabled="checkFilters === 0"
                type="button"
                @click="resetFilter"
                class="pageheader__filters-buttons-clear"
              >
                <i class="clear"></i>
                <span> Clear </span>
              </button>
            </slot>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<style lang="scss" scoped>
@import "./pageHeader.scss";
</style>
